.boxes {
	margin-top: var(--mantine-spacing-xs);
	margin-bottom: var(--mantine-spacing-xs);
}
